import { Pagination } from '@material-ui/lab';
import React from 'react';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const CustomPagination = ({ page, pageSize, total = 0, isLoading, onPageChange = (page) => null }) => {
    const handleChange = (event, value) => {
        onPageChange(value);
    };

    const getCurrentPageRange = () => {
        let currentPageRange = page * pageSize;

        if (currentPageRange > total) {
            currentPageRange = total;
        }

        return currentPageRange;
    };

    return (
        <SLayout>
            <div>
                Showing {total ? ((page - 1) * pageSize + 1) : 0} to {getCurrentPageRange()} of {total} entries
            </div>
            <Pagination
                disabled={isLoading}
                onChange={handleChange}
                count={Math.ceil(total / pageSize)}
                page={page}
                variant="outlined"
                shape="rounded"
            />
        </SLayout>
    );
};

export default CustomPagination;
